// Hook can be either
//  1. something dispatchable
//    - an action
//    - a thunk
//    - a promise
//  2. or a function that returns something dispatchable
export default (dispatch, hooks) => {
  const isActionCreator = func => typeof func === 'function';
  const isPromise = prom => prom && typeof prom.then === 'function';

  return Promise.all(
    hooks.map(actionCreator => {
      const dispatchableOrPromise = isActionCreator(actionCreator)
        ? actionCreator()
        : actionCreator;

      // if it is a promise convert to dispatchable
      const dispatchable = isPromise(dispatchableOrPromise)
        ? () => dispatchableOrPromise
        : dispatchableOrPromise;

      return dispatchable && dispatch(dispatchable);
    })
  );
};
